<template>
  <div class="position-relative">
    <div class="shadow-st" v-if="showShadow">
      <div class="inner-text">*플랜 변경 후 이용 가능합니다.</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: "InnerView",
    props: {
      showShadow: {
        type: Boolean,
        default: false
      }
    },
    created() {
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {}
  }
</script>
<style lang="stylus" scoped>
  .shadow-st
    background-color #040404
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    z-index 2
    opacity 0.56
  .inner-text
    display flex
    justify-content flex-end
    margin 10px
    color white
    font-weight 500
    font-size 15px
</style>
